import { styled } from '@mui/material/styles';
import { Chip } from '@mui/material';

export const StyledChip = styled(Chip)(({ theme }) => ({
  borderRadius: `calc(${theme.shape.borderRadius}px * 3)`,
  fontWeight: theme.typography.fontWeightMedium,
  transition: theme.transitions.create([
    'background-color',
    'box-shadow',
    'transform',
  ], {
    duration: theme.transitions.duration.short,
  }),
  
  '&.MuiChip-clickable': {
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: theme.shadows[2],
    },
    
    '&:active': {
      transform: 'translateY(0)',
      boxShadow: theme.shadows[1],
    },
  },
  
  '&.MuiChip-sizeSmall': {
    fontSize: '9px',
    height: '16px',
    
    '& .MuiChip-label': {
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
    },
  },
  
  '&.MuiChip-sizeMedium': {
    height: 32,
    fontSize: theme.typography.body2.fontSize,
    
    '& .MuiChip-label': {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
    },
  },
  
  '&.MuiChip-colorSuccess': {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.success.contrastText,
    
    '&.MuiChip-outlined': {
      backgroundColor: 'transparent',
      color: theme.palette.success.main,
      borderColor: theme.palette.success.main,
    },
  },
  
  '&.MuiChip-colorError': {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    
    '&.MuiChip-outlined': {
      backgroundColor: 'transparent',
      color: theme.palette.error.main,
      borderColor: theme.palette.error.main,
    },
  },
  
  '&.MuiChip-colorWarning': {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.warning.contrastText,
    
    '&.MuiChip-outlined': {
      backgroundColor: 'transparent',
      color: theme.palette.warning.main,
      borderColor: theme.palette.warning.main,
    },
  },
  
  '&.MuiChip-colorInfo': {
    backgroundColor: theme.palette.info.main,
    color: theme.palette.info.contrastText,
    
    '&.MuiChip-outlined': {
      backgroundColor: 'transparent',
      color: theme.palette.info.main,
      borderColor: theme.palette.info.main,
    },
  },
  
  // Unicity color variants - using proper contrastText for accessibility
  '&.MuiChip-colorUnicityGreen': {
    backgroundColor: theme.palette.unicityGreen?.main || '#43C06F',
    color: theme.palette.unicityGreen?.contrastText || '#ffffff',
    '&.MuiChip-outlined': {
      backgroundColor: 'transparent',
      color: theme.palette.unicityGreen?.main || '#43C06F',
      borderColor: theme.palette.unicityGreen?.main || '#43C06F',
    },
  },

  '&.MuiChip-colorUnicityBlue': {
    backgroundColor: theme.palette.unicityBlue?.main || '#009ECF',
    color: theme.palette.unicityBlue?.contrastText || '#ffffff',
    '&.MuiChip-outlined': {
      backgroundColor: 'transparent',
      color: theme.palette.unicityBlue?.main || '#009ECF',
      borderColor: theme.palette.unicityBlue?.main || '#009ECF',
    },
  },

  '&.MuiChip-colorUnicityPurple': {
    backgroundColor: theme.palette.unicityPurple?.main || '#BA71AA',
    color: theme.palette.unicityPurple?.contrastText || '#ffffff',
    '&.MuiChip-outlined': {
      backgroundColor: 'transparent',
      color: theme.palette.unicityPurple?.main || '#BA71AA',
      borderColor: theme.palette.unicityPurple?.main || '#BA71AA',
    },
  },

  '&.MuiChip-colorUnicityOrange': {
    backgroundColor: theme.palette.unicityOrange?.main || '#FFA77B',
    color: theme.palette.unicityOrange?.contrastText || '#ffffff',
    '&.MuiChip-outlined': {
      backgroundColor: 'transparent',
      color: theme.palette.unicityOrange?.main || '#FFA77B',
      borderColor: theme.palette.unicityOrange?.main || '#FFA77B',
    },
  },

  '&.MuiChip-colorUnicityNavy': {
    backgroundColor: theme.palette.unicityNavy?.main || '#183A5A',
    color: theme.palette.unicityNavy?.contrastText || '#ffffff',
    '&.MuiChip-outlined': {
      backgroundColor: 'transparent',
      color: theme.palette.unicityNavy?.main || '#183A5A',
      borderColor: theme.palette.unicityNavy?.main || '#183A5A',
    },
  },
  
  '& .MuiChip-deleteIcon': {
    color: 'inherit',
    fontSize: '1.2em',
    
    '&:hover': {
      color: theme.palette.action.active,
    },
  },
})); 